import {computed, hasInjectionContext} from 'vue'
import {useRoute} from 'vue-router'
import {useCurrentAppPlatform} from '@toolify/client/src/modules/platform/composables/useCurrentAppPlatform'
import {ClientRouteParamType} from '@toolify/client/src/setup/router/enum/ClientRouteParamType'
import {getGuestThemeQueryValue} from '@toolify/client/src/modules/authentication/functions/getGuestThemeQueryValue'
import {getStoredGuestTheme} from '@toolify/client/src/modules/authentication/functions/getStoredGuestTheme'
import {resolveGuestLocaleType} from '@toolify/client/src/modules/authentication/functions/resolveGuestLocaleType'
import {resolveGuestThemeType} from '@toolify/client/src/modules/authentication/functions/resolveGuestThemeType'

export function useGuestAppearance() {
  const route = hasInjectionContext() ? useRoute() : null
  const {currentAppPlatformType} = useCurrentAppPlatform()

  const locale = computed(() => {
    return resolveGuestLocaleType({
      routeLocale: route?.params[ClientRouteParamType.Locale],
      appPlatformType: currentAppPlatformType,
    })
  })

  const theme = computed(() => {
    return resolveGuestThemeType({
      queryTheme: getGuestThemeQueryValue(route?.query),
      storedTheme: getStoredGuestTheme(),
      appPlatformType: currentAppPlatformType,
    })
  })

  return {
    locale,
    theme,
  }
}
